import Splide from '@splidejs/splide';

var actusSlider = new Splide('[actus-slider]', {
    arrows : false,
    arrowPath: '',
    gap: '20px'
});

actusSlider.mount();
